export default "__VITE_ASSET__drGypuVb__"